/// <reference types="./ai_response.d.mts" />
import * as $bright from "../../../../bright/bright.mjs";
import * as $copilot_message from "../../../../common/data/copilot_message.mjs";
import * as $metadata from "../../../../common/data/copilot_message/metadata.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $copy_button from "../../../../ds/ds/components/copy_button.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $text from "../../../../ds/ds/typography/text.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $html from "../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $model from "../../../data/model.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $common from "../../../frontend/view/common.mjs";
import * as $shared from "../../../frontend/view/copilot/shared.mjs";
import * as $s from "../../../frontend/view/styles/copilot.mjs";
import { toList, makeError, isEqual } from "../../../gleam.mjs";

const FILEPATH = "src/frontend/view/copilot/ai_response.gleam";

function errored_bubble() {
  return $l.column(
    toList([$l.align("start")]),
    toList([]),
    toList([
      $l.column(
        toList([$l.gap(16), $l.align("start")]),
        toList([]),
        toList([
          $s.error_response_bubble(
            toList([]),
            toList([
              $h.text("An internal error happened at Steerlab.\n"),
              $h.text(
                "Please, contact your administrator, or start a new conversation.",
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function ai_skeleton() {
  let _pipe = $l.column(
    toList([$l.gap(32)]),
    toList([]),
    toList([
      $l.column(
        toList([$l.align("end"), $l.gap(6)]),
        toList([]),
        toList([
          $skeleton.skeleton(300, 15),
          $skeleton.skeleton(300, 15),
          $skeleton.skeleton(300, 15),
          $skeleton.skeleton(50, 20),
          $l.row(
            toList([$l.gap(10)]),
            toList([]),
            toList([$skeleton.skeleton(60, 20), $skeleton.skeleton(60, 20)]),
          ),
        ]),
      ),
      $l.column(
        toList([$l.gap(6)]),
        toList([]),
        toList([
          $skeleton.skeleton(300, 15),
          $skeleton.skeleton(300, 15),
          $l.column(
            toList([$l.gap(12)]),
            toList([]),
            toList([
              $skeleton.skeleton(300, 15),
              $skeleton.skeleton(60, 20),
              $skeleton.skeleton(120, 15),
            ]),
          ),
          $skeleton.skeleton(120, 15),
        ]),
      ),
    ]),
  );
  return $list.wrap(_pipe);
}

function question_tags(model, question) {
  let state = $bright.state(model);
  let no_question_tags = $list.is_empty(question.display.tags);
  let no_org_tags = $list.is_empty(state.organization.tags);
  return $bool.lazy_guard(
    no_org_tags || no_question_tags,
    $el.none,
    () => {
      return $l.row(
        toList([$l.gap(8)]),
        toList([]),
        $list.filter_map(
          question.display.tags,
          (tag) => {
            let tag$1 = $list.find(
              state.organization.tags,
              (t) => { return t.id === tag; },
            );
            return $result.map(
              tag$1,
              (tag) => {
                return $label.label(toList([$label.content(tag.name)]));
              },
            );
          },
        ),
      );
    },
  );
}

function user_bubble(model, message, is_last) {
  let $ = message.metadata;
  if (!($ instanceof $metadata.User)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "frontend/view/copilot/ai_response",
      83,
      "user_bubble",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 2561,
        end: 2614,
        pattern_start: 2572,
        pattern_end: 2595
      }
    )
  }
  let content = $.content;
  return $l.fragment(
    toList([
      $shared.show_loading_answer(is_last),
      $l.column(
        toList([$l.align("end")]),
        toList([]),
        toList([
          $s.question_bubble(
            toList([]),
            toList([$h.text(content), question_tags(model, message)]),
          ),
        ]),
      ),
    ]),
  );
}

function question_answer_actions(question) {
  let score = question.display.score;
  let _block;
  let $1 = question.metadata;
  if ($1 instanceof $metadata.Deprecated) {
    _block = [
      $copilot_message.answer(question),
      $copilot_message.content(question),
    ];
  } else if ($1 instanceof $metadata.Errored) {
    _block = [new $option.None(), ""];
  } else if ($1 instanceof $metadata.System) {
    _block = [new $option.None(), ""];
  } else if ($1 instanceof $metadata.Developer) {
    _block = [new $option.None(), ""];
  } else if ($1 instanceof $metadata.User) {
    _block = [new $option.None(), ""];
  } else if ($1 instanceof $metadata.Tool) {
    _block = [new $option.None(), ""];
  } else {
    let content = $1.content;
    _block = [content, ""];
  }
  let $ = _block;
  let answer = $[0];
  let question$1 = $[1];
  return $l.column(
    toList([$l.align("start")]),
    toList([]),
    toList([
      (() => {
        if (answer instanceof Some) {
          if (score instanceof Some) {
            let $2 = score[0];
            if ($2 === 0.0) {
              return $el.none();
            } else {
              let answer$1 = answer[0];
              let on_click = new $msg.UserAddedCopilotToQuestionBank(
                question$1,
                answer$1,
              );
              let on_qb_click = $e.on_click(on_click);
              return $l.row(
                toList([$l.gap(10)]),
                toList([]),
                toList([
                  $button.inlay(
                    toList([on_qb_click]),
                    toList([
                      $icons.tiny($icons.add()),
                      $el.text("Add to question bank"),
                    ]),
                  ),
                  $copy_button.copy_button(
                    toList([
                      $copy_button.actionable(true),
                      $copy_button.content(answer$1),
                    ]),
                  ),
                ]),
              );
            }
          } else {
            let answer$1 = answer[0];
            let on_click = new $msg.UserAddedCopilotToQuestionBank(
              question$1,
              answer$1,
            );
            let on_qb_click = $e.on_click(on_click);
            return $l.row(
              toList([$l.gap(10)]),
              toList([]),
              toList([
                $button.inlay(
                  toList([on_qb_click]),
                  toList([
                    $icons.tiny($icons.add()),
                    $el.text("Add to question bank"),
                  ]),
                ),
                $copy_button.copy_button(
                  toList([
                    $copy_button.actionable(true),
                    $copy_button.content(answer$1),
                  ]),
                ),
              ]),
            );
          }
        } else {
          return $el.none();
        }
      })(),
    ]),
  );
}

function question_answer_bubble(message) {
  if (message instanceof $copilot_message.CopilotMessage) {
    let content = $copilot_message.content(message);
    return $s.response_bubble(toList([]), toList([$h.text(content)]));
  } else {
    let answer = $copilot_message.answer(message);
    let $ = message.display.score;
    if ($ instanceof Some) {
      if (answer instanceof Some) {
        let x = $[0];
        if (x > 0.0) {
          let answer$1 = answer[0];
          return $s.response_bubble(toList([]), toList([$h.text(answer$1)]));
        } else {
          return $s.error_response_bubble(
            toList([]),
            toList([
              $h.text("Steerlab is unable to get an answer for you.\n"),
              $h.text("Please, ask another question."),
            ]),
          );
        }
      } else {
        return $s.error_response_bubble(
          toList([]),
          toList([
            $h.text("Steerlab is unable to get an answer for you.\n"),
            $h.text("Please, ask another question."),
          ]),
        );
      }
    } else {
      return $s.error_response_bubble(
        toList([]),
        toList([
          $h.text("Steerlab is unable to get an answer for you.\n"),
          $h.text("Please, ask another question."),
        ]),
      );
    }
  }
}

function from_dict(dict, key) {
  let _pipe = dict;
  let _pipe$1 = $dict.get(_pipe, key);
  return $result.unwrap(_pipe$1, toList([]));
}

function get_sources(model, question) {
  let state = $bright.state(model);
  return [
    from_dict(state.proposals.elements.data_points, question.id),
    from_dict(state.proposals.elements.data_sources, question.id),
  ];
}

function question_answer_sources(model, question) {
  let state = $bright.state(model);
  let is_score_zero = isEqual(question.display.score, new Some(0.0));
  let should_skip = $list.is_empty(question.data_points_id) || is_score_zero;
  return $bool.lazy_guard(
    should_skip,
    $el.none,
    () => {
      let $ = get_sources(model, question);
      let data_points = $[0];
      let data_sources = $[1];
      return $common.sources_row(
        model,
        question.id,
        state.language,
        data_points,
        data_sources,
      );
    },
  );
}

function answer_bubble(model, question) {
  return $l.column(
    toList([$l.gap(16), $l.align("start")]),
    toList([]),
    toList([
      (() => {
        let _pipe = question_answer_bubble(question);
        return $el.map(_pipe, (var0) => { return new $msg.Copilot(var0); });
      })(),
      (() => {
        let _pipe = question_answer_actions(question);
        return $el.map(_pipe, (var0) => { return new $msg.Copilot(var0); });
      })(),
      $html.div(
        $text.xs($text.regular),
        toList([]),
        toList([question_answer_sources(model, question)]),
      ),
    ]),
  );
}

function assistant_bubble(model, message) {
  return $l.column(
    toList([$l.align("start")]),
    toList([]),
    toList([answer_bubble(model, message)]),
  );
}

function view_copilot_message(model, message, is_last) {
  let metadata = message.metadata;
  if (metadata instanceof $metadata.Deprecated) {
    return $el.none();
  } else if (metadata instanceof $metadata.Errored) {
    return errored_bubble();
  } else if (metadata instanceof $metadata.System) {
    return $el.none();
  } else if (metadata instanceof $metadata.Developer) {
    return $el.none();
  } else if (metadata instanceof $metadata.User) {
    return user_bubble(model, message, is_last);
  } else if (metadata instanceof $metadata.Tool) {
    return $el.none();
  } else {
    let $ = metadata.tool_calls;
    if ($ instanceof Some) {
      return $shared.tool_bubble(is_last);
    } else {
      return assistant_bubble(model, message);
    }
  }
}

function questions_answers(model, props) {
  return $s.questions_answers_column(
    toList([]),
    $bool.lazy_guard(
      props.is_loading,
      ai_skeleton,
      () => {
        let $ = props.thread;
        if ($ instanceof Some) {
          let thread = $[0];
          return $list.index_map(
            thread.messages,
            (message, index) => {
              let is_last = index === 0;
              if (message instanceof $copilot_message.CopilotMessage) {
                return view_copilot_message(model, message, is_last);
              } else {
                return $l.column(
                  toList([$l.gap(32)]),
                  toList([]),
                  toList([
                    $l.column(
                      toList([$l.align("end")]),
                      toList([]),
                      toList([
                        $s.question_bubble(
                          toList([]),
                          toList([
                            $h.text(message.content),
                            question_tags(model, message),
                          ]),
                        ),
                      ]),
                    ),
                    answer_bubble(model, message),
                  ]),
                );
              }
            },
          );
        } else {
          return toList([]);
        }
      },
    ),
  );
}

export function view(model, id) {
  let props = $shared.props(model, id);
  return $s.card_wrapper(
    toList([]),
    toList([
      $shared.history(model, props),
      $s.main_content(
        toList([]),
        toList([
          questions_answers(model, props),
          (() => {
            let _pipe = $shared.copilot_input(model, props);
            return $el.map(_pipe, (var0) => { return new $msg.Copilot(var0); });
          })(),
        ]),
      ),
    ]),
  );
}
